// import { Column, Grid } from "@carbon/react";

import {
  CdsColumn,
  CdsGrid,
  Card,
  ChartWithSummary,
  CurrencyDisplay,
  SummaryTable,
  PeriodFilter,
  DatePopOver,
  ActivationRequiredWarning,
  Select,
} from "../../components";
import { QuickSummaryColumData } from "./QuickSummaryColumnData";
import { formatNumberWithCommas } from "../../utils";
import { IHomeViewProps, sumChartValues } from "./Home";
import { SetupAccountModal } from "./SetupAccountModal";
import { chartTypes, transactionStatus } from "../../enums";

export const View = ({
  showOnboardingRequiredModal,
  closeOnboardingRequiredModal,

  chartPeriodDisplayFormatter,

  monthlyOrYearlyQueryStringTabs,
  navigateToRoute,
  navigateToAccountSetup,
  summaryTableData,
  quickSummaryColumData,

  // for charts
  defaultCurrency,
  // primary_withdrawal_currency,
  timeStampNow,

  // payouts
  isLoadingPayoutsSummary,
  isErrorPayoutsSummary,
  payoutsSummary,

  // todays transactions
  isLoadingTodaysTransaction,
  isErrorTodaysTransaction,
  todaysTransactions,

  // transactions by period
  isLoadingTransactionsByPeriod,
  isErrorTransactionsByPeriod,
  transactionsByPeriod,

  // transactions by gateway
  isLoadingTransactionsByGateway,
  isErrorTransactionsByGateway,
  transactionsByGateway,

  gatewayChartTxStatus,
  setGatewayChartTxStatus,

  chartType,
  setChartType,

  // customers by period
  // isLoadingCustomersByPeriod,
  // isErrorCustomersByPeriod,
  // customersByPeriod,

  // data by category
  todayGrossSales,
  totalSalesChartData,
  totalTransactionsChartData,
  transactionsByGatewayChartData,
  totalSuccessfulTransactionsChartData,
  totalFailedTransactionsChartData,
  totalCustomersChartData,

  startChartPeriod,
  endChartPeriod,
  setStartChartPeriodFromDatePicker,
  setEndChartPeriodFromDatePicker,
}: IHomeViewProps) => {
  return (
    <>
      <ActivationRequiredWarning
        title="You need to activate your profile to enjoy the full benefits of SwitchApp "
        subtitle="Our guide will help you complete your Business profile and you’ll start receiving payments. Click this banner to complete your set-up"
        urlTarget="/onboarding"
      />

      <CdsGrid fullWidth>
        {/* <SetupAccordion /> */}
        <SetupAccountModal
          isModalOpen={showOnboardingRequiredModal}
          closeModal={closeOnboardingRequiredModal}
          navigateToOnboarding={navigateToAccountSetup}
        />

        <CdsColumn sm={4} md={6} lg={16}>
          <h3>
            <strong>Today</strong>
          </h3>
        </CdsColumn>

        <CdsColumn sm={4} md={8} lg={12}>
          <CdsGrid>
            <CdsColumn sm={4} md={8} lg={12}>
              <QuickSummaryColumData
                quickSummaryColumData={quickSummaryColumData}
              />
            </CdsColumn>

            <CdsColumn sm={4} md={8} lg={12}>
              <Card>
                <CdsGrid>
                  <ChartWithSummary
                    isLoading={isLoadingTodaysTransaction}
                    isError={isErrorTodaysTransaction}
                    chartXAxisStartLabel={"12.00 AM"}
                    chartXAxisStopLabel={timeStampNow.toString()}
                    chartTitle={"Gross Volume"}
                    chartDataMultiSeries={[
                      {
                        label: defaultCurrency,
                        data: todayGrossSales,
                      },
                    ]}
                    chartLabelClassName={"chart-label--large"}
                    total={
                      todaysTransactions ? (
                        <CurrencyDisplay
                          currencyOrSymbol={defaultCurrency}
                          amount={sumChartValues(todaysTransactions)}
                        />
                      ) : (
                        "--"
                      )
                    }
                    hasSummaryData
                    summaryRightTopTitle={"Available Balance"}
                    summaryRightTopUrl={"/balances"}
                    // summaryRightTopText={"Overall Transactions"}
                    summaryRightTopText={"In Your Wallet"}
                    summaryRightTopValue={
                      payoutsSummary?.wallet_balance ? (
                        <CurrencyDisplay
                          currencyOrSymbol={defaultCurrency}
                          amount={payoutsSummary.wallet_balance}
                        />
                      ) : (
                        "--"
                      )
                    }
                    summaryRightBottomTitle={"Payouts"}
                    summaryRightBottomUrl={"/balances/payouts"}
                    summaryRightBottomText={"Will be Deposited Tomorrow 4 P.M."} // {"Deposited June 29"}
                    summaryRightBottomValue={
                      payoutsSummary?.today_payouts_amount ? (
                        <CurrencyDisplay
                          currencyOrSymbol={defaultCurrency}
                          amount={payoutsSummary?.today_payouts_amount}
                        />
                      ) : (
                        "--"
                      )
                    }
                  />
                </CdsGrid>
              </Card>
            </CdsColumn>
          </CdsGrid>
        </CdsColumn>

        <CdsColumn sm={4} md={8} lg={4}>
          <Card>
            <SummaryTable
              Title="Last 30 days"
              navigateToRoute={navigateToRoute}
              data={summaryTableData}
            />
          </Card>
        </CdsColumn>

        <CdsColumn sm={4} md={8} lg={16} className="reports">
          <div className="flex-container flex-break--small align-items--end align-content--end">
            <h4 className="section-title font-ctm--bold">Reports Overview</h4>

            {/* Tab Filters */}
            <div className="flex-box flex-container align-items--end no-wrap">
              <div style={{ width: "170px" }}>
                <PeriodFilter />
              </div>
              <DatePopOver
                name="period-select-datepicker"
                label=""
                startDate={startChartPeriod}
                endDate={endChartPeriod}
                setStartDate={setStartChartPeriodFromDatePicker}
                setEndDate={setEndChartPeriodFromDatePicker}
              />
            </div>

            <div className="flex-container mt-5">
              <div className="button-tabs mr-5">
                {/* <QuickTableFilterTabs
                  queryStringTabNavLinks={monthlyOrYearlyQueryStringTabs}
                  tabListType={"contained"}
                /> */}
              </div>

              <div>
                {/* <SwitchAppButton
                  size="md"
                  kind="tertiary"
                  className="switchapp-themed edit-chart--button"
                  onClick={() => {}}
                >
                  <img
                    src={settingsIcon}
                    alt="edit chart icon"
                    className="edit-chart--icon"
                  />
                  Edit chart
                </SwitchAppButton> */}

                <div className="ml-5">
                  <Select
                    name="chartTypeSelect"
                    label=""
                    placeholder="Select chart type"
                    className="font-ctm--bold small--select"
                    selectItems={[
                      {
                        text: `${chartTypes.area} chart`,
                        value: chartTypes.area,
                      },
                      {
                        text: `${chartTypes.line} chart`,
                        value: chartTypes.line,
                      },
                      {
                        text: `${chartTypes.bar} chart`,
                        value: chartTypes.bar,
                      },
                      {
                        text: `${chartTypes.bubble} chart`,
                        value: chartTypes.bubble,
                      },
                    ]}
                    onChange={(e) => setChartType(e.target.value)}
                    value={chartType}
                  />
                </div>
              </div>
            </div>
          </div>
        </CdsColumn>

        <CdsColumn sm={4} md={8} lg={16}>
          <Card>
            <CdsGrid className="chart-row--first" fullWidth>
              <ChartWithSummary
                // {...smallChartsData[0]}
                isLoading={isLoadingTransactionsByPeriod}
                isError={isErrorTransactionsByPeriod}
                chartType={chartType}
                chartDataMultiSeries={[
                  {
                    label: defaultCurrency,
                    data: totalSalesChartData,
                  },
                ]}
                chartXAxisStartLabel={chartPeriodDisplayFormatter(
                  startChartPeriod
                )}
                chartXAxisStopLabel={chartPeriodDisplayFormatter(
                  endChartPeriod
                )}
                total={
                  <CurrencyDisplay
                    currencyOrSymbol={defaultCurrency}
                    amount={totalSalesChartData.reduce(
                      (acc, pnt) => acc + (pnt?.y || 0),
                      0
                    )}
                  />
                }
                chartTitle={"Total Sales"}
                description={
                  "Total sales before deducting any fees refunds or disputes"
                }
              />

              <ChartWithSummary
                isLoading={isLoadingTransactionsByPeriod}
                isError={isErrorTransactionsByPeriod}
                chartType={chartType}
                chartXAxisStartLabel={chartPeriodDisplayFormatter(
                  startChartPeriod
                )}
                chartXAxisStopLabel={chartPeriodDisplayFormatter(
                  endChartPeriod
                )}
                chartDataMultiSeries={[
                  {
                    label: defaultCurrency,
                    data: totalTransactionsChartData,
                  },
                ]}
                total={
                  isErrorTransactionsByPeriod
                    ? "--"
                    : `${
                        transactionsByPeriod?.length
                          ? formatNumberWithCommas(
                              transactionsByPeriod.reduce(
                                (acc, tx) => acc + tx.count,
                                0
                              )
                            )
                          : "--"
                      }`
                }
                chartTitle="Total Transactions"
                description="Overall number of transactions"
              />

              <ChartWithSummary
                isLoading={isLoadingTransactionsByPeriod}
                isError={isErrorTransactionsByPeriod}
                chartType={chartType}
                chartXAxisStartLabel={chartPeriodDisplayFormatter(
                  startChartPeriod
                )}
                chartXAxisStopLabel={chartPeriodDisplayFormatter(
                  endChartPeriod
                )}
                chartDataMultiSeries={[
                  {
                    label: defaultCurrency,
                    data: totalSuccessfulTransactionsChartData,
                  },
                ]}
                total={totalSuccessfulTransactionsChartData.reduce(
                  (acc, pnt) => acc + (pnt?.y || 0),
                  0
                )}
                chartTitle={"Successful transactions"}
                description={"Number of successful transfers"}
              />

              <ChartWithSummary
                isLoading={isLoadingTransactionsByPeriod}
                isError={isErrorTransactionsByPeriod}
                chartType={chartType}
                chartXAxisStartLabel={chartPeriodDisplayFormatter(
                  startChartPeriod
                )}
                chartXAxisStopLabel={chartPeriodDisplayFormatter(
                  endChartPeriod
                )}
                chartDataMultiSeries={[
                  {
                    label: defaultCurrency,
                    data: totalCustomersChartData,
                  },
                ]}
                total={`${formatNumberWithCommas(
                  totalCustomersChartData.reduce(
                    (acc, pnt) => acc + (pnt?.y || 0),
                    0
                  )
                )}`}
                chartTitle="Total Customers"
                description="Overall number of customers"
                // chartType="bar"
              />
            </CdsGrid>

            <CdsGrid fullWidth>
              <ChartWithSummary
                isLoading={isLoadingTransactionsByPeriod}
                isError={isErrorTransactionsByPeriod}
                chartType={chartType}
                chartXAxisStartLabel={chartPeriodDisplayFormatter(
                  startChartPeriod
                )}
                chartXAxisStopLabel={chartPeriodDisplayFormatter(
                  endChartPeriod
                )}
                chartDataMultiSeries={[
                  {
                    label: defaultCurrency,
                    data: totalFailedTransactionsChartData,
                  },
                ]}
                total={totalFailedTransactionsChartData.reduce(
                  (acc, pnt) => acc + (pnt?.y || 0),
                  0
                )}
                chartTitle={"Unsuccessful transactions"}
                description={"Number of unsuccessful transfers"}
              />

              <ChartWithSummary
                isLoading={isLoadingTransactionsByGateway}
                isError={isErrorTransactionsByGateway}
                chartType={chartType}
                chartXAxisStartLabel={chartPeriodDisplayFormatter(
                  startChartPeriod
                )}
                chartXAxisStopLabel={chartPeriodDisplayFormatter(
                  endChartPeriod
                )}
                chartDataMultiSeries={transactionsByGatewayChartData}
                total={
                  <div className="flex-container justify-content--between">
                    <span>
                      {isErrorTransactionsByGateway
                        ? "--"
                        : `${
                            transactionsByGateway
                              ? formatNumberWithCommas(
                                  transactionsByGateway.reduce(
                                    (allGwAcc, txGrp) =>
                                      allGwAcc +
                                      txGrp.transaction_by_period.reduce(
                                        (gwAcc, tx) => gwAcc + tx.count,
                                        0
                                      ),
                                    0
                                  )
                                )
                              : "0"
                          }`}
                    </span>

                    <Select
                      name="balanceCurrencySelect"
                      label=""
                      placeholder="Select currency"
                      className="font-ctm--bold small--select"
                      // showSkeleton={props.isLoadingBalances}
                      hideSkeletonLabel
                      selectItems={[
                        {
                          text: "successful",
                          value: transactionStatus.successful,
                        },
                        {
                          text: "failed",
                          value: transactionStatus.failed,
                        },
                        {
                          text: "abandoned",
                          value: transactionStatus.abandoned,
                        },
                        {
                          text: "refunded",
                          value: transactionStatus.refunded,
                        },
                        {
                          text: "processing",
                          value: transactionStatus.processing,
                        },
                      ]}
                      onChange={(e) => setGatewayChartTxStatus(e.target.value)}
                      value={gatewayChartTxStatus}
                    />
                  </div>
                }
                chartTitle={"Transactions By Gateway"}
                description={"Statistics of gateways used for your payments"}
              />

              <ChartWithSummary
                isLoading={isLoadingTransactionsByPeriod}
                isError={isErrorTransactionsByPeriod}
                chartType={chartType}
                chartXAxisStartLabel={chartPeriodDisplayFormatter(
                  startChartPeriod
                )}
                chartXAxisStopLabel={chartPeriodDisplayFormatter(
                  endChartPeriod
                )}
                chartDataMultiSeries={[
                  {
                    label: defaultCurrency,
                    data: totalFailedTransactionsChartData.map((entry) => ({
                      ...entry,
                      y: 0,
                    })),
                  },
                ]}
                total={0}
                chartTitle={"High Risk Payments"}
                description={"We track risky payments for you"}
              />

              <ChartWithSummary
                isLoading={isLoadingTransactionsByPeriod}
                isError={isErrorTransactionsByPeriod}
                chartType={chartType}
                chartXAxisStartLabel={chartPeriodDisplayFormatter(
                  startChartPeriod
                )}
                chartXAxisStopLabel={chartPeriodDisplayFormatter(
                  endChartPeriod
                )}
                chartDataMultiSeries={[
                  {
                    label: defaultCurrency,
                    data: totalFailedTransactionsChartData.map((entry) => ({
                      ...entry,
                      y: 0,
                    })),
                  },
                ]}
                total={0}
                suffix={"%"}
                chartTitle={"Dispute Activity"}
                description={"---"}
              />
            </CdsGrid>
          </Card>
        </CdsColumn>
      </CdsGrid>
    </>
  );
};
